"use client";

import { useEffect } from "react";
import { hotjar } from "react-hotjar";

export function HotjarTracking({ hotjarId }: { hotjarId: string }) {
  useEffect(() => {
    hotjar.initialize({ id: parseInt(hotjarId, 10), sv: 6 });
  }, [hotjarId]);

  return null;
}
